"use client"

import { useState } from "react"
import { motion } from "framer-motion"
import { Instagram, Loader2 } from "lucide-react"

const MaintenancePage = () => {
  const [email, setEmail] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setSubmitStatus(null)

    const formData = new FormData()
    formData.append("email", email)
    formData.append("access_key", "aed76c14-eaa2-48cc-b48a-0e479fa85f4b")

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      })

      const data = await response.json()
      if (data.success) {
        setSubmitStatus("success")
        setEmail("")
      } else {
        setSubmitStatus("error")
      }
    } catch (error) {
      setSubmitStatus("error")
    }

    setIsSubmitting(false)
  }

  return (
    <div className="bg-gray-900 min-h-screen flex flex-col items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-gray-800 p-8 rounded-lg shadow-lg max-w-md w-full"
      >
        <div className="flex justify-center mb-6">
          <motion.div
            whileHover={{ scale: 1.1, rotate: 15 }}
            whileTap={{ scale: 0.9 }}
            className="bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-500 p-2 rounded-2xl"
          >
            <Instagram size={48} className="text-white" />
          </motion.div>
        </div>

        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-2xl font-bold text-center text-white mb-4"
        >
          This Page is Coming Soon
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-center text-gray-300 mb-6"
        >
          We're working hard to bring you something amazing. Stay tuned!
        </motion.p>

        <div className="space-y-4">
          {["Photos", "Videos", "Stories", "Reels"].map((feature, index) => (
            <motion.div
              key={feature}
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4 + index * 0.1 }}
              className="flex items-center space-x-3 bg-gray-700 p-3 rounded-lg"
            >
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span className="text-gray-200">{feature}</span>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="mt-8 text-center"
        >
          <p className="text-sm text-gray-300">Want to be notified when we launch?</p>
          <form onSubmit={handleSubmit} className="mt-2">
            <div className="flex">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-grow px-4 py-2 bg-gray-700 text-white border border-gray-600 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <button
                type="submit"
                className="bg-blue-500 text-white px-4 py-2 rounded-r-lg hover:bg-blue-600 transition duration-300 flex items-center justify-center"
                disabled={isSubmitting}
              >
                {isSubmitting ? <Loader2 className="animate-spin" /> : "Notify Me"}
              </button>
            </div>
          </form>
          {submitStatus === "success" && <p className="mt-2 text-green-400">Thank you for subscribing!</p>}
          {submitStatus === "error" && <p className="mt-2 text-red-400">An error occurred. Please try again.</p>}
        </motion.div>
      </motion.div>

      <motion.footer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="mt-8 text-center text-gray-400 text-sm"
      >
        © 2025 InstagramClone. All rights reserved.
      </motion.footer>
    </div>
  )
}

export default MaintenancePage

